<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <div class="head-img">
      <img :src="headImg">
    </div>
    <!-- 核心服务-->
    <div class="core-service">
      <div class="title">
        <h2>核心服务</h2>
        <div class="common-border"></div>
        <h4>每年，我们将16%的销售收入投入研发，其中30%的研发经费投入高端技术的预研</h4>
      </div>
      <div class="core-container">
        <div  class="core-item" v-for="(item,index) in coreitem" :key="index" >
          <div v-bind:class="[isdefult,{'is-on':index == add}]" @mouseenter="changeCore($event)" :data-id="index"><i class="icon iconfont">&#xe612;</i>{{item.text}}</div>
          <div v-bind:class="[isimg,{'is-onimg':index == add}]">
            <img :src="item.img">
          </div>
          <div class="button" :data-id="item.id" :class="{'is-onimg':index == add}" @click="service"><span>了解详情</span></div>
        </div>
      </div>

    </div>
    <!--解决方案-->
<!--    <div class="solution">-->
<!--        <div class="title">-->
<!--          <h2>解决方案</h2>-->
<!--          <p>PRODUCTS AND PROJECTS</p>-->
<!--        </div>-->
<!--      <div class="solution-bolck">-->
<!--        <div class="solution-item-container">-->
<!--          <div class="solution-item">-->
<!--            <ul v-bind:class="defulte" v-for="(item,index) in solutionimg" :key="index">-->
<!--              <li v-bind:class="item.class_name">-->
<!--                <a href="javascript:;" v-on:mouseenter="changeActive ($event)" v-on:mouseleave="removeActive ($event)" v-bind:title="item.title">-->
<!--                  <img :src="base_url+item.imgUrl">-->
<!--                  <div class="text">-->
<!--                    <h2>{{item.name}}</h2>-->
<!--                    <p>{{item.ename}}</p>-->
<!--                  </div>-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!--新闻动态-->
<!--    <div class="new">-->
<!--      <div class="title">-->
<!--        <h2>成熟的场景化解决方案</h2>-->
<!--        <h4>让数据被合理、合规、安全的流动与使用，实现数据全生命周期的安全合规和风险管理</h4>-->
<!--      </div>-->
<!--      <el-carousel :interval="4000" type="card" height="400px">-->
<!--        <el-carousel-item v-for="(item,index) in bannerList" :key="index">-->
<!--          <div class="inner-context">-->
<!--            <span>{{item.contents}}</span>-->
<!--            <img :src="base_url+item.imgUrl">-->
<!--            <span class="name">{{item.name}}</span>-->
<!--          </div>-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
<!--    </div>-->
    <!--成功客户-->
    <div class="success-customer">
<!--      <img :src="successimg">-->
      <div class="title">
        <h2>成熟的场景化解决方案</h2>
        <div class="common-border"></div>
        <h4>让数据被合理、合规、安全的流动与使用，实现数据全生命周期的安全合规和风险管理</h4>
      </div>
      <swiper class="successswiper" :options="swipersuccessOption" ref="mysuccessswiper">
        <swiper-slide class="success-slide" :class="{'is_light':index == islight}" v-for="(item,index) in solutionimg" :key="index" :data-index="index" @mouseenter="changeLight($event)">
          <div class="inner-success" :data-index="index"  @mouseenter="changeLight($event)">
            <i class="iconfont" :class="item.icon"></i>
            <span class="name">{{item.name}}</span>
            <span class="name-border"></span>
            <span class="tip-top">{{item.tiptop}}</span>
            <span class="tip">{{item.tip}}</span>
            <span class="tips"><i class="icon iconfont">&#xe691;</i><div>{{item.discript1}}</div></span>
            <span class="tips"><i class="icon iconfont tips">&#xe691;</i><div>{{item.discript2}}</div></span>
            <span v-if="item.discript3" class="tips"><i class="icon iconfont">&#xe691;</i>{{item.discript3}}</span>
            <span class="success-button" @click="soluton">了解详情</span>
          </div>
        </swiper-slide>
<!--        <a class="swiper-button-prev" slot="button-prev" @click="prevsuccess"></a>-->
<!--        <a class="swiper-button-next" slot="button-next" @click="nextsuccess"></a>-->
      </swiper>
    </div>
    <div class="img-title">
      <h2>未来5年服务客户</h2>
      <div class="common-border"></div>
      <div class="img-title-container">
        <div class="img-titile-item" v-for="(item,index) in imgTitle" :key="index">
          <div class="title-img"><img :src="item.img"></div>
          <div class="title-text">{{item.text}}</div>
        </div>
      </div>
    </div>
    <!-- 指导体系-->
    <div class="guidance">
      <h2>完整数据安全运营支撑指导体系</h2>
      <div class="common-border"></div>
      <h4>通过技术研发，构建统一数据安全协同运营平台，深化安全数据应用，支撑大数据”汇、融、治、用、惠“关键环节的风险感知及应对，提供以”4服务+1平台“的数据安全治理解决方案</h4>
      <div class="guidance-container">
        <div class="guidance-item" :class="{'is-show':index == add2}"  :data-id="index" v-for="(item,index) in guidenceInfo" :key="index" @mouseenter="changeGuidance($event)">
          <div class="guidance-item-title" :data-id="index">
            <i class="icon iconfont" :class="item.icon" :data-id="index"></i>
            <span :data-id="index">{{item.title}}</span>
          </div>
          <div class="guidance-text" :data-id="index">{{item.text}}</div>
        </div>
      </div>
    </div>
   <!--最新动态-->
    <div class="news">
      <h2>最新动态</h2>
      <div class="common-border"></div>
      <h4>了解我们近期的活动和新闻动态</h4>
      <div class="news-container">
        <div class="news-item" :class="{'is-click':index == add3}"  :data-id="index" v-for="(item,index) in newsInfo" :key="index" @mouseenter="changeNews($event)">
          <div class="news-date" :data-id="index">
            <div class="year" :data-id="index">{{item.year}}</div>
            <div class="time" :data-id="index">{{item.date}}</div>
            <div class="border" :data-id="index"><div></div></div>
          </div>
          <div class="news-text" :data-id="index">
            <div class="news-title" :data-id="index"><span></span>{{item.name}}</div>
            <div class="news-brief" :data-id="index">{{item.contents}}</div>
            <div class="news-detail" :data-id="item.id" @click="newsDetail">资讯详情<i class="iconfont">&#xe6b0;</i></div>
          </div>
          <div class="news-img" :data-id="index"><img :src="item.imgUrl"></div>
        </div>
      </div>
    </div>
    <!--安全服务-->
    <div class="service">
      <h2>与多行业建立战略合作</h2>
      <div class="common-border"></div>
      <h4>以安全监管部门、行业安全主管部门、关键行业、关键领域为核心客户，以模式创新、技术创新、产业运营为支点，构建安全数字经济产业生态域</h4>
      <div class="service-img">
        <div v-bind:class="['service-item',{'is-img':index == isImg}]" v-for="(item,index) in serviceText" :key="index" :data-id="index" @mouseenter="changeImg($event)">
          {{item}}
        </div>
      </div>
    </div>
    <!--页脚-->
    <Footer></Footer>
  </div>
</template>

<script>
  import home from './home';
  export default home;
</script>

<style scoped>
  @import "home.css";
  @import "../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue